// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"443":"about","943":"partners"}[chunkId] + "." + {"443":"0c8c961f","943":"1d238f64"}[chunkId] + ".css";
};